var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLimbotHappy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 229,
    viewBox: "0 0 206 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Limbot-Happy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M164.877 89.9888C164.877 89.9888 163.217 123.215 130.961 128.964",
    stroke: "#5E6574",
    strokeWidth: 1.47301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M170.774 90.9004C171.256 88.1273 169.019 85.4644 165.778 84.9528C162.538 84.4412 159.52 86.2745 159.038 89.0476C158.556 91.8208 160.793 94.4836 164.034 94.9953C167.274 95.5069 170.292 93.6736 170.774 90.9004Z",
    fill: "#4BD1CE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M170.774 90.9004C171.256 88.1273 169.019 85.4644 165.778 84.9528C162.538 84.4412 159.52 86.2745 159.038 89.0476C158.556 91.8208 160.793 94.4836 164.034 94.9953C167.274 95.5069 170.292 93.6736 170.774 90.9004Z",
    stroke: "#5E6574",
    strokeWidth: 1.47301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M80.7242 148.002C81.8308 170.153 95.9393 191.803 112.206 191.064C128.5 190.326 140.782 167.463 139.676 145.312C138.569 123.162 118.9 118.731 108.803 119.18C97.1841 119.707 79.6177 125.878 80.7242 148.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M80.7242 148.002C81.8308 170.153 95.9393 191.803 112.206 191.064C128.5 190.326 140.782 167.463 139.676 145.312C138.569 123.162 118.9 118.731 108.803 119.18C97.1841 119.707 79.6177 125.878 80.7242 148.002Z",
    stroke: "#5E6574",
    strokeWidth: 1.47301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M112.615 123.951C132.254 120.846 146.255 107.3 143.888 93.6939C141.521 80.0882 123.682 71.5754 104.043 74.6799C84.4044 77.7845 70.4029 91.3309 72.7699 104.937C75.137 118.542 92.9763 127.055 112.615 123.951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M115.819 113.576C130.123 111.705 140.546 102.046 139.1 92.0043C137.654 81.9622 124.886 75.3388 110.582 77.2105C96.2787 79.0823 85.8556 88.7404 87.3018 98.7825C88.7479 108.825 101.516 115.448 115.819 113.576Z",
    fill: "#454C5E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M112.615 123.951C132.254 120.846 146.255 107.3 143.888 93.6939C141.521 80.0882 123.682 71.5754 104.043 74.6799C84.4044 77.7845 70.4029 91.3309 72.7699 104.937C75.137 118.542 92.9763 127.055 112.615 123.951Z",
    stroke: "#5E6574",
    strokeWidth: 1.47301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M111.016 92.5173C111.182 93.3615 112.04 93.9154 112.925 93.7572C113.811 93.5989 114.391 92.7811 114.225 91.937L111.016 92.5173Z",
    fill: "#4BD1CE",
    stroke: "#4BD1CE",
    strokeWidth: 1.47301,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M133.063 90.1989C132.482 87.5619 129.771 85.8742 127.005 86.4279C124.238 86.9817 122.468 89.566 123.049 92.203",
    stroke: "#4BD1CE",
    strokeWidth: 1.47301,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M103.491 95.34C102.91 92.703 100.199 91.0153 97.4326 91.5691C94.6662 92.1228 92.8957 94.7071 93.4767 97.3441",
    stroke: "#4BD1CE",
    strokeWidth: 1.47301,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.2,
    d: "M108.747 217.832C127.845 217.832 143.327 215.176 143.327 211.899C143.327 208.622 127.845 205.966 108.747 205.966C89.6495 205.966 74.1677 208.622 74.1677 211.899C74.1677 215.176 89.6495 217.832 108.747 217.832Z",
    fill: "#5E6574"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M44.511 108.452C44.511 108.452 54.9126 139.832 87.5835 137.802",
    stroke: "#5E6574",
    strokeWidth: 1.47301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M44.6749 112.017C47.9591 111.96 50.5745 109.636 50.5166 106.825C50.4587 104.015 47.7493 101.783 44.4651 101.84C41.1809 101.897 38.5655 104.221 38.6234 107.032C38.6813 109.842 41.3907 112.074 44.6749 112.017Z",
    fill: "#4BD1CE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M50.6664 106.94C50.6795 104.129 48.0273 101.839 44.7425 101.825C41.4576 101.811 38.7841 104.079 38.771 106.89C38.7579 109.7 41.4101 111.99 44.695 112.004C47.9798 112.018 50.6533 109.751 50.6664 106.94Z",
    stroke: "#5E6574",
    strokeWidth: 1.47301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M127.78 123.297L122.994 120.976C122.828 120.897 122.634 120.897 122.468 120.976C119.564 122.295 113.92 123.455 110.13 123.798C100.614 124.668 92.7574 123.033 92.6744 123.007C92.4531 122.954 92.2318 123.033 92.0935 123.191L90.6827 124.721C90.5443 124.853 90.489 125.064 90.5443 125.248C90.5997 125.433 90.738 125.591 90.9316 125.644C97.0177 127.701 102.772 128.386 107.696 128.386C111.264 128.386 114.418 128.017 116.991 127.569C123.575 126.382 127.641 124.404 127.807 124.325C128.001 124.22 128.139 124.035 128.139 123.824C128.112 123.587 127.973 123.376 127.78 123.297Z",
    fill: "#5E6574"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M122.966 165.357C130.159 163.748 134.613 156.945 132.925 150.141C131.238 143.338 124.073 139.119 116.908 140.727C109.743 142.336 105.262 149.139 106.949 155.943C108.636 162.746 115.801 166.965 122.966 165.357Z",
    stroke: "#5E6574",
    strokeWidth: 1.47301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M121.887 160.952C126.507 159.924 129.384 155.546 128.305 151.169C127.226 146.791 122.606 144.075 117.987 145.104C113.367 146.132 110.49 150.51 111.569 154.887C112.675 159.291 117.267 161.981 121.887 160.952Z",
    fill: "#596DAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M118.845 148.509L116.19 156.815L125.097 154.811L118.845 148.509Z",
    stroke: "white",
    strokeWidth: 1.47301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M121.666 47.8037C121.666 47.8037 124.82 51.7065 130.629 52.5503C137.213 53.526 140.312 59.1956 140.312 59.1956L136.577 66.5528C136.577 66.5528 131.957 61.1733 127.393 60.435C121.473 59.4593 117.793 55.4247 117.793 55.4247L121.666 47.8037Z",
    fill: "#78BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M45.203 37.3623C45.203 37.3623 47.5821 40.2894 51.9529 40.9486C56.9047 41.687 59.2285 45.9589 59.2285 45.9589L56.4345 51.4967C56.4345 51.4967 52.9765 47.4357 49.5185 46.8819C45.0647 46.1435 42.2983 43.111 42.2983 43.111L45.203 37.3623Z",
    fill: "#FC9EC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M142.768 43.2549C142.768 43.2549 145.147 46.182 149.518 46.8412C154.47 47.5796 156.794 51.8515 156.794 51.8515L154 57.3892C154 57.3892 150.542 53.3283 147.084 52.7745C142.63 52.0361 139.863 49.0036 139.863 49.0036L142.768 43.2549Z",
    fill: "#FC9EC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M34.2763 75.8838C34.2763 75.8838 36.0191 78.0461 39.2281 78.5208C42.8521 79.0482 44.5949 82.2126 44.5949 82.2126L42.5201 86.2736C42.5201 86.2736 39.975 83.2938 37.43 82.8719C34.1656 82.3445 32.1185 80.103 32.1185 80.103L34.2763 75.8838Z",
    fill: "#FEE1ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M54.9133 65.6768C54.9133 65.6768 57.7903 69.2103 63.0464 70.0014C69.0218 70.898 71.8435 76.0402 71.8435 76.0402L67.2513 84.7159C67.2513 84.7159 63.0741 79.8375 58.9245 79.1519C53.5578 78.2817 50.2104 74.6162 50.2104 74.6162L54.9133 65.6768Z",
    fill: "#FADE92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M94.1685 31.5571C94.1685 31.5571 96.188 34.0623 99.9226 34.6161C104.155 35.2489 106.147 38.888 106.147 38.888L102.883 45.0322C102.883 45.0322 99.9226 41.5778 96.9902 41.1031C93.2003 40.4966 90.8212 37.8859 90.8212 37.8859L94.1685 31.5571Z",
    fill: "#4BD1CE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M147.061 72.854C147.061 72.854 148.748 74.9372 151.847 75.3855C155.36 75.9129 157.02 78.9455 157.02 78.9455L155.028 82.8746C155.028 82.8746 152.566 80.0003 150.132 79.6047C146.978 79.1037 145.014 76.9414 145.014 76.9414L147.061 72.854Z",
    fill: "#F4F1FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M161.641 57.4263C161.641 57.4263 163.771 60.0633 167.671 60.6434C172.098 61.3027 174.2 65.1263 174.2 65.1263L171.683 70.0839C171.683 70.0839 168.584 66.4448 165.486 65.9438C161.502 65.2845 159.013 62.5684 159.013 62.5684L161.641 57.4263Z",
    fill: "#FFA584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M85.2883 52.9448C85.2883 52.9448 87.4184 55.5818 91.319 56.162C95.7452 56.8212 97.8477 60.6449 97.8477 60.6449L95.3303 65.6025C95.3303 65.6025 92.2319 61.9634 89.1336 61.4624C85.15 60.8031 82.6603 58.087 82.6603 58.087L85.2883 52.9448Z",
    fill: "#A1DCF1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M52.5065 91.1362C52.5065 91.1362 54.6366 93.7732 58.5372 94.3534C62.9634 95.0126 65.0658 98.8363 65.0658 98.8363L62.5484 103.794C62.5484 103.794 59.4501 100.155 56.3517 99.6538C52.3682 98.9945 49.8784 96.2784 49.8784 96.2784L52.5065 91.1362Z",
    fill: "#A1DCF1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimbotHappy);
export default __webpack_public_path__ + "static/media/LimbotHappy.db35104731193ad0dd739ea87817e6df.svg";
export { ForwardRef as ReactComponent };